<template>
    <div class="panel employee-list">
        <div class="row mb-3">
            <div v-if="employeeList.length > 0" class="col-md-12">
                <table class="table table-hover">
                    <thead>
                        <tr class="font-weight-bold small">
                            <th style="width: 40px;" class="text-right">#</th>
                            <th>{{ $t("#TR-code") }}</th>
                            <th>{{ $t("#TR-name") }}</th>
                            <!-- <th>Status</th>-->
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in employeeList" :key="idx">
                            <td class="text-right">{{ idx + 1 }}</td>
                            <td>{{ item.code }}</td>
                            <td>{{ item.name }}</td>
                            <!-- <td>{{item.status}}</td>-->
                            <td class="receipt-btn preview"
                                @click="employeeView(item)">
                                <span class="mdi mdi-eye"></span>
                            </td>
                            <td class="receipt-btn edit"
                                @click="employeeEdit(item)">
                                <span class="mdi mdi-pencil"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="employeeList.length < 1 && !employeeFilter" class="col-md-12 text-center text-muted my5">
                {{ $t("#TR-no-restaurant-and-role-selected") }}
            </div>
            <div v-if="employeeList.length < 1 && employeeFilter" class="col-md-12 text-center text-muted my5">
                <span v-if="!employeeFilter.selectedRole.guid">{{ $t("#TR-select-role") }}</span>
                <span v-if="employeeFilter.selectedRole.guid">{{ $t("#TR-no-employees-found") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmployeeList',
    props: {
        employeeList: {
            default: () => {
                return null;
            },
            type: Array
        },
        employeeFilter: {
            default: () => {
                return null;
            },
            type: Object
        }
    },

    data() {
        return {};
    },

    methods: {
        employeeEdit(item) {
            this.$emit('employeeEdit', item);
        },

        employeeView(item) {
            this.$emit('employeeView', item);
        }
    }
};
</script>

<style lang="stylus" scoped>

</style>
